import axios from 'axios';
import { API_URL, APIS, KEYS, STORAGE, URLS } from '../../_config';


const axiosApiInstance = axios.create();

var retrying = false;
const waitForRetry = () => {
	var timer:any = null
	return new Promise((resolve) => {
		timer = setInterval(() => {
			if (!retrying) {
				clearInterval(timer);
				resolve(true);
			}
		}, 1000);
	})
}



axiosApiInstance.interceptors.response.use((response: any) => {
	return response
}, async function (error: any) {
	console.log('Interceptor ERROR - ',error, error.response)
	const originalRequest = error.config;
	if ((error.response?.status == 401 || error.code == 'ERR_NETWORK' )&& !originalRequest._retry) {
		if (retrying) {
			// Wait for the ongoing refresh to complete
			await waitForRetry();
			originalRequest._retry = true;
			const token = localStorage.getItem(KEYS.AUTH_ACCESS);
			if (token) {
				originalRequest.headers['Authorization'] = 'Bearer ' + token;
				return axiosApiInstance(originalRequest);
			} else {
				// If no token after waiting, redirect to login
				localStorage.removeItem('persist:root')
				localStorage.removeItem(STORAGE);
				localStorage.removeItem(KEYS.AUTH_ACCESS);
				localStorage.removeItem(KEYS.AUTH_REFRESH);
				(window as any).location.href = URLS.AUTH.LOGIN;
				return Promise.reject(error);
			}
		} else {
			retrying = true;
			originalRequest._retry = true;
			try {
				const access_token = await refreshAccessToken();
				if (access_token) {
					originalRequest.headers['Authorization'] = 'Bearer ' + access_token;
					return axiosApiInstance(originalRequest);
				} else {
					console.error('Failed to refresh token - logging out');
					retrying = false;
					return Promise.reject(error);
				}
			} catch (refreshError) {
				console.error('Exception during token refresh:', refreshError);
				retrying = false;
				return Promise.reject(error);
			}
		}
	} else {
		const status = error.response?.status;
		console.log('Interceptor ELSE - ', status);
		if (status === 401 || status === 403) {
			localStorage.removeItem('persist:root');
			localStorage.removeItem(STORAGE);
			localStorage.removeItem(KEYS.AUTH_ACCESS);
			localStorage.removeItem(KEYS.AUTH_REFRESH);
			(window as any).location.href = URLS.AUTH.LOGIN;
		}
	}
	return Promise.reject(error);
});



const refreshAccessToken = async () => {
	let token = null;
	let userData:any = localStorage.getItem(STORAGE);
	if (userData) {
		try {
			userData = JSON.parse(userData);
		} catch (e) {
			console.error('Failed to parse user data:', e);
			retrying = false;
			logoutUser();
			return null;
		}
	}
	
	const refreshToken = getRefreshToken();
	if (!refreshToken) {
		console.error('No refresh token available');
		retrying = false;
		logoutUser();
		return null;
	}
	
	let payload = {
		"refreshToken": refreshToken,
		"userID": userData?.userID,
		"userEmail": userData?.emailID,
	}
	
	// Use fetch instead of axios to avoid interceptor loop and potential axios issues
	const headers = {
		'Content-Type': 'application/json',
		'AppHost': new URL(window?.location?.href).hostname
	};
	
	// Construct proper API URL
	const apiUrl = APIS.AUTH.REFRESH_TOKEN.startsWith('http') 
		? APIS.AUTH.REFRESH_TOKEN 
		: `${API_URL}${APIS.AUTH.REFRESH_TOKEN}`;
	
	try {
		console.log('Attempting refresh token call...');
		console.log('Payload:', payload);
		console.log('URL:', apiUrl);
		
		const response = await fetch(apiUrl, {
			method: 'POST',
			headers: headers,
			body: JSON.stringify(payload)
		});
		
		console.log('refresh token response status =>', response.status);
		console.log('refresh token response headers =>', Object.fromEntries(response.headers.entries()));
		
		if (response.ok) {
			const responseText = await response.text();
			console.log('Raw response text =>', responseText);
			
			let data;
			try {
				data = JSON.parse(responseText);
			} catch (parseError) {
				console.error('JSON parse error:', parseError);
				console.error('Response text that failed to parse:', responseText);
				throw new Error('Invalid JSON response');
			}
			
			console.log('refresh token response data =>', data);
			
			// Check the correct response structure for your API
			let responseToken = null;
			let refreshToken = null;
			
			if (data?.authenticateDataModel?.[0]?.responseToken && data?.authenticateDataModel?.[0]?.refreshToken) {
				// Your API structure
				responseToken = data.authenticateDataModel[0].responseToken;
				refreshToken = data.authenticateDataModel[0].refreshToken;
			} else if (data?.responseToken && data?.refreshToken) {
				// Direct structure
				responseToken = data.responseToken;
				refreshToken = data.refreshToken;
			} else if (data?.accessToken && data?.refreshToken) {
				// Alternative structure
				responseToken = data.accessToken;
				refreshToken = data.refreshToken;
			} else if (data?.data?.responseToken && data?.data?.refreshToken) {
				// Nested data structure
				responseToken = data.data.responseToken;
				refreshToken = data.data.refreshToken;
			}
			
			if (responseToken && refreshToken) {
				console.log('Tokens found - saving...');
				saveToken(responseToken, refreshToken);
				token = responseToken;
				retrying = false;
			} else {
				console.error('No valid token found in response. Response structure:', data);
				throw new Error('Invalid response format - no tokens found');
			}
		} else {
			const errorText = await response.text();
			console.error('Response not ok:', response.status, response.statusText);
			console.error('Error response body:', errorText);
			
			// Check if refresh token is expired or invalid
			if (response.status === 401 || response.status === 403) {
				console.error('Refresh token expired or invalid - forcing logout');
				throw new Error('Refresh token expired');
			}
			
			throw new Error(`HTTP ${response.status}: ${response.statusText}`);
		}
	} catch (error2) {
		console.error('Refresh token error:', error2);
		retrying = false;
		logoutUser();
		return null; // Return null on error
	}
	
	return token;
}

function logoutUser() {
	console.log('Logging out user - clearing all tokens');
	localStorage.removeItem('persist:root');
	localStorage.removeItem(STORAGE);
	localStorage.removeItem(KEYS.AUTH_ACCESS);
	localStorage.removeItem(KEYS.AUTH_REFRESH);
	(window as any).location.href = URLS.AUTH.LOGIN;
}

function saveToken(accessToken: any, refreshToken: any) {


//localStorage.setItem(STORAGE,JSON.stringify(resp.data?.authenticateDataModel?.[0]));
			localStorage.setItem(KEYS.AUTH_ACCESS,accessToken);
			localStorage.setItem(KEYS.AUTH_REFRESH,refreshToken );

			/* yield put({
				type: ACTIONS.USER.LOGIN,
				payload: {
					user: resp.data?.authenticateDataModel?.[0],
					accessToken: resp.data?.authenticateDataModel?.[0].responseToken,
					refreshToken: resp.data?.authenticateDataModel?.[0].refreshToken,
					isAuthenticated: true,
					permissions: true
				}
			}) */


	let token_str = localStorage.getItem(STORAGE)
	if (token_str) {
		let data = JSON.parse(token_str)
		data.accessToken = accessToken
		data.refreshToken = refreshToken;
		localStorage.setItem(STORAGE, JSON.stringify(data))
	}
}

function getToken() {
	return localStorage.getItem(KEYS.AUTH_ACCESS);
}


function getRefreshToken() {
	const refreshToken = localStorage.getItem(KEYS.AUTH_REFRESH);
	if (!refreshToken || refreshToken === 'null' || refreshToken === 'undefined') {
		console.warn('Invalid or missing refresh token');
		return null;
	}
	return refreshToken;
}


const apiCatch = (error: any) => {
	if (error.response && error.response.status === 401 && window.location.pathname != URLS.AUTH.LOGIN) {
		//localStorage.removeItem(STORAGE)
		window.location.href = process.env.PUBLIC_URL + URLS.AUTH.LOGIN
	}
}


export const responseHandler = (resp: any) => {
	if (resp.status >= 200 && resp.status < 300 && resp.data) {
		if (resp.data.data.exceptions?.length) {
			return { status: false, data: resp.data.data.exceptions.join(',') }
		} else {
			return { status: true, data: resp.data }
		}
	} else {
		return { status: false, data: resp.data }
	}
}

export class CallApi {
	static GET(url: any, params: any, isAuth: boolean = false, isAdaptive: boolean = false) {
		return new Promise(async (resolve, reject) => {
			let urls = new URL(window?.location?.href);
			let headers: any = {
				'Content-Type': 'application/json',
				AppHost: urls.hostname
			}
			if (isAuth || isAdaptive) {
				let token = getToken()
				if (token) {
					headers.Authorization = `Bearer ${token}`
				}
			}

			let config: any = { method: 'GET', url, headers, params }

			if (isAdaptive) {
				config = { method: 'GET', url, headers, params, responseType: 'arraybuffer' }
			}

			return axiosApiInstance(config).then((success: any) => {
				return resolve(success)
			}).catch((error: any) => {
				apiCatch(error)
				return reject(error.response)
			})
		})
	}

	static POST(url: any, params: any, isAuth: boolean = false, isAdaptive: boolean = false, onUploadProgress: any = (e: any) => { }) {
		return new Promise((resolve, reject) => {
			const urls = new URL(window?.location?.href)
			let headers: any = {}
			const token = getToken()
			if (isAuth || token) {
				const token = getToken()
				if (token) {
					headers.Authorization = `Bearer ${token}`
					headers.AppHost = urls.hostname
				}
			} else {
				headers.AppHost = urls.hostname
			}
			let config: any = { headers, onUploadProgress }

			if (isAdaptive) {
				config = { headers, onUploadProgress, responseType: 'arraybuffer' }
			}
			return axiosApiInstance.post(url, params, config).then((success: any) => {
				return resolve(success)
			}).catch((error: any) => {
				apiCatch(error)
				return reject(error.response)
			})
		})
	}

	static PUT(url: string, params: any, isAuth: boolean = false, isAdaptive: any = (e: any) => { }) {
		return new Promise((resolve, reject) => {
			const urls = new URL(window?.location?.href)
			let headers: any = { 'Content-Type': 'application/json' }
			if (isAuth || isAdaptive) {
				const token = getToken()
				if (token) {
					headers.Authorization = `Bearer ${token}`
					headers.AppHost = urls.hostname
				}
			} else {
				headers.AppHost = urls.hostname
			}
			return axiosApiInstance.put(url, params, { headers: headers, onUploadProgress: isAdaptive }).then((success: any) => {
				return resolve(success)
			}).catch((error: any) => {
				apiCatch(error)
				return reject(error.response)
			})
		})
	}

	static DELETE(url: string, params: any, isAuth: boolean = false, isAdaptive: any = (e: any) => { }) {
		return new Promise((resolve, reject) => {
			const urls = new URL(window?.location?.href)
			let headers: any = { 'Content-Type': 'application/json' }
			const token = getToken()
			if (isAuth || token) {
				if (token) {
					headers.Authorization = `Bearer ${token}`
					headers.AppHost = urls.hostname
				}
			} else {
				headers.AppHost = urls.hostname
			}

			return axiosApiInstance.delete(url, { headers: headers, onUploadProgress: isAdaptive, data: params }).then((success: any) => {
				return resolve(success)
			}).catch((error: any) => {
				apiCatch(error)
				return reject(error.response)
			})
			/* return axiosApiInstance({ method: 'DELETE', url, headers, params, }).then(success => {
				return resolve(success)
			}).catch(error => {
				apiCatch(error)
				return reject(error.response)
			}) */
		})
	}
}
